// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import { Table, TableBody, TableCell, TableHead, TableRow, TextField } from '@mui/material'
import { Mutation } from 'react-apollo'
import isEqual from 'lodash/isEqual'
import { i18n } from '../../index'
import css from './hesburgerEfficiencyBoundaryTable.css'
import { upsertHesburgerEfficiencyBoundary } from '../../station/stationQueries'
import type { HesburgerEfficiencyBoundary } from '../../station/stationTypes'
import '../../station/stationTypes'

type HesburgerEfficiencyBoundaryTableProps = {
  data: HesburgerEfficiencyBoundary
  stationId: string
}

const defaultState: HesburgerEfficiencyBoundary = {
  ipShare: 0,
  avgPurchase: 0,
  salesMargin: 0,
  productWastage: 0,
  raWastage: 0,
  inventoryDifferences: 0,
  intakes: 0,
  readinessCheeseBurger: 0,
  readinessDoubleBurger: 0,
  readinessCampaign: 0,
}

const fields: (keyof HesburgerEfficiencyBoundary)[] = [
  'ipShare',
  'avgPurchase',
  'readinessDoubleBurger',
  'readinessCheeseBurger',
  'readinessCampaign',
  'salesMargin',
  'inventoryDifferences',
  'raWastage',
  'productWastage',
  'intakes',
]

class HesburgerEfficiencyBoundaryTable extends React.Component<HesburgerEfficiencyBoundaryTableProps> {
  constructor(props) {
    super(props)
    const data = props.data ? props.data : defaultState
    this.state = { ...data }
  }

  componentDidUpdate(prevProps: HesburgerEfficiencyBoundaryTableProps) {
    if (!isEqual(this.props.data, prevProps.data)) {
      this.setState({ ...this.props.data })
    }
  }

  onSubmit = (onMutate: (...args: Array<any>) => any) => {
    const notNullData = {}
    Object.keys(this.state).forEach((key) => {
      if (fields.includes(key)) {
        notNullData[key] = !isNaN(parseFloat(this.state[key])) ? parseFloat(this.state[key]) : 0
      }
    })
    onMutate({
      variables: {
        stationId: this.props.stationId,
        boundary: { ...notNullData },
      },
    })
  }
  onChange = (key, value) => {
    this.setState({
      [key]: value,
    })
  }

  render() {
    return (
      <div>
        <Table>
          <TableHead>
            <TableRow>
              {fields.map((field) => (
                <TableCell key={field} className={css.tableCell}>
                  {i18n.t(`admin.stations.title.hesburgerTable.${field}`)}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              {fields.map((field) => (
                <Mutation key={field} mutation={upsertHesburgerEfficiencyBoundary}>
                  {(onMutate) => (
                    <TableCell className={css.tableCell}>
                      <TextField
                        type={'number'}
                        onBlur={() => this.onSubmit(onMutate)}
                        value={this.state[field]}
                        onChange={(e) => this.onChange(field, e.target.value)}
                      />
                    </TableCell>
                  )}
                </Mutation>
              ))}
            </TableRow>
          </TableBody>
        </Table>
      </div>
    )
  }
}

export default HesburgerEfficiencyBoundaryTable
